// src/web/components/left-sidebar-group-list.jsx

import React from 'react'
import ui from '../../helpers/ui-state'
import _ from 'lodash'
import {
  List,
  ListItem,
  ListSubHeader,
  ListDivider,
} from 'react-toolbox/lib/list'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import Input from './compact-input.jsx'
import compactListTheme from './themes/compact-list.css'
import leftSidebarGroupListItemTheme from './themes/left-sidebar-group-list-item.css'
import CardTitleRightActions from './card-title-right-actions'
import Tooltip from 'react-toolbox/lib/tooltip'
import logoPng from "../images/logo.png";


const TooltipIconButton = Tooltip(IconButton)

function LeftSidebarGroupList(props) {
  const onSelectGroup = (group_id) => {
    props.ui.searchInput && props.updateUI({ searchInput: false }), props.onSearchChange('')
    props.selectGroup && props.selectGroup(group_id)
  }
  const onSelectDivision = (division_id) => {
    props.ui.searchInput && props.updateUI({ searchInput: false }), props.onSearchChange('')
    props.selectDivision && props.selectDivision(division_id), props.expandDivision(division_id)
  }
  const onSelectDivisionNotSetGroup = (division_id) => {
    props.ui.searchInput && props.updateUI({ searchInput: false }), props.onSearchChange('')
    props.selectDivisionNotSetGroup && props.selectDivisionNotSetGroup(division_id)
    props.expandDivisionNotSetGroup && !props.canExpandDivNotSetGroup && props.expandDivisionNotSetGroup()
  }
  const {
    t,
    ui,
    currentGroupId,
    currentDivisionId,
    groups,
    divisions,
    otherGroups,
    labelText,
    selectGroup,
    selectDivision,
    onSearchChange,
    onCreateGroup,
    onSortGroup,
    openSortGroup,
    updateUI,
    isFilter,
    onFilter,
    unreadGroups,
    menuItems,
    expandDivision,
    collapseDivision,
    expandedDivisions,
    expandDivisionNotSetGroup,
    canExpandDivNotSetGroup,
    selectDivisionNotSetGroup
  } = props

  const visibleGroups = isFilter ? (unreadGroups || []) : (groups || [])
  const groupsOnSet = visibleGroups.filter(item => !item.is_free_group)
  const groupsNotSet = visibleGroups.filter(item => item.is_free_group && (item.is_member || item.favorite))
  const totalDivision = menuItems.filter(function (menuItem) {
    const subGroupsId = menuItems.filter(menu => menu.type == 'group' && menu.parent_id == menuItem.item_id).map(menu => menu.item_id)
    const hasSubMenu = groupsOnSet.find(group => subGroupsId.includes(group.group_id) )
    return menuItem.type == 'division' && hasSubMenu
  }).length

  return (
    <List selectable theme={compactListTheme}>
      <ListSubHeader caption={
        !ui.searchInput &&
        <div style={{ display: 'flex'}}>
          <div>{labelText}</div>
          {(onSearchChange || onCreateGroup) &&
            <div style={{ marginLeft: 'auto' }}>
              {<TooltipIconButton  tooltip={t("label:未読のみ表示")} icon={isFilter ? "filter_alt" : "filter_alt_off"} onClick={onFilter} style={{background: isFilter && "rgb(170, 170, 170, 0.5)"}}/>}
              <TooltipIconButton tooltip={t('label:並べ替え')} icon="swap_vert" onClick={openSortGroup} />
              {onCreateGroup && <TooltipIconButton tooltip={t('label:グループ新規作成')} icon="add_circle_outline" onClick={onCreateGroup} />}
              <TooltipIconButton tooltip={t('label:セクション/グループ名を検索')} icon="search" onClick={()=> updateUI({ searchInput: true })} />
            </div>}
        </div> ||
        <div style={{ display: 'flex'}}>
          <Input type="text" className="fluid"
              hasFocus
              onChange={onSearchChange} />
          <div style={{ marginLeft: 'auto' }}>
            <IconButton icon="close" onClick={()=> { updateUI({ searchInput: false }); onSearchChange('')}} />
          </div>
        </div>
      } />
      {groupsOnSet && _.map(menuItems, (menuItem, i)=> {
        const menuExtra = menuItem.type == 'division'
          ? divisions.find(d => d.division_id == menuItem.item_id) : groupsOnSet.find(g => g.group_id == menuItem.item_id)
        const subGroupsId = menuItems.filter(menu => menu.type == 'group' && menu.parent_id == menuItem.item_id).map(menu => menu.item_id)
        const hasSubMenu = groupsOnSet.find(group => subGroupsId.includes(group.group_id) )
        let rightAction
        if(menuItem.type == 'division' && !expandedDivisions.includes(menuItem.item_id))
          rightAction = [<IconButton key="expand_sub_groups" icon="expand_more" onClick={()=> expandDivision(menuItem.item_id)} />]
        if(menuItem.type == 'division' && expandedDivisions.includes(menuItem.item_id))
          rightAction = [<IconButton key="collapse_sub_groups" icon="expand_less" onClick={()=> collapseDivision(menuItem.item_id)} />]
        if (menuItem.type == 'division' && !hasSubMenu) return null
        if (menuItem.type == 'division')
          return menuExtra && (<ListItem theme={leftSidebarGroupListItemTheme}
            className={(menuExtra.division_id == currentDivisionId && 'active' || '')}
            caption={menuExtra.name} key={menuExtra.division_id}
            avatar={menuExtra.icon_image.thumb_url}
            style={{height:5, width: 5, backgroundColor: '#000', borderRadius: 20}}
            onClick={()=> onSelectDivision(menuExtra.division_id, props) }
            rightActions={rightAction || []}/>)
          return menuExtra && (expandedDivisions.includes(menuItem.parent_id)) && (
            <ListItem theme={leftSidebarGroupListItemTheme}
              className={(menuExtra.group_id == currentGroupId && 'active' || '')+ (' indent ')+menuExtra.access_type}
              caption={menuExtra.name} key={menuItem.parent_id + '.' + menuExtra.group_id}
              avatar={menuExtra.icon_image.thumb_url}
              rightActions={menuExtra.unreadCount && [<span key='count' className={leftSidebarGroupListItemTheme.unreadCount}>{menuExtra.unreadCount < 10 ? menuExtra.unreadCount : '10+' }</span>] || []}
              onClick={()=> onSelectGroup(menuExtra.group_id, props) } />)
          }
      )}
      {totalDivision > 0 && groupsNotSet.length > 0 &&
          (<ListItem
                     key={'division_group_not_set'}
                     theme={leftSidebarGroupListItemTheme}
                     className={currentDivisionId == 0 ? 'active' : ''}
                     caption={t('label:セクションなし')}
                     avatar={logoPng}
                     style={{height:5, width: 5, backgroundColor: '#000', borderRadius: 20}}
                     onClick={() => onSelectDivisionNotSetGroup('new', props)}
                     rightActions={[
                         <IconButton
                             key={!canExpandDivNotSetGroup ? "expand_sub_groups" : "collapse_sub_groups"}
                             icon={!canExpandDivNotSetGroup ? "expand_more" : "expand_less"}
                             onClick={expandDivisionNotSetGroup}
                         />]}
                     />)
      }
      {(canExpandDivNotSetGroup || totalDivision === 0) && groupsNotSet && _.map(menuItems, (menuItem, i)=> {
            const menuExtra = groupsNotSet.find(g => g.group_id == menuItem.item_id && menuItem.is_free_group)
            return menuExtra && (
                <ListItem theme={leftSidebarGroupListItemTheme}
                          className={(menuExtra.group_id == currentGroupId && 'active' || '')+ (totalDivision > 0 ? ' indent ' : '')+menuExtra.access_type}
                          caption={menuExtra.name} key={(totalDivision > 0 ? menuItem.parent_id + '.' : '') + menuExtra.group_id}
                          avatar={menuExtra.icon_image.thumb_url}
                          rightActions={menuExtra.unreadCount && [<span key='count' className={leftSidebarGroupListItemTheme.unreadCount}>{menuExtra.unreadCount < 10 ? menuExtra.unreadCount : '10+' }</span>] || []}
                          onClick={()=> onSelectGroup(menuExtra.group_id, props) } />)
          }
      )}
      {isFilter && unreadGroups.length == 0 &&
        <ListItem theme={leftSidebarGroupListItemTheme}
          ripple={false}
          caption={t('label:未読グループがありません')} />
      }
      {(!totalDivision && (!groups || groups.length === 0)) || (totalDivision > 0 && groupsOnSet.length === 0) &&
        <ListItem theme={leftSidebarGroupListItemTheme}
          ripple={false}
          caption={t('label:セクション/グループはありません')} />
      }
      {ui.show && otherGroups && <ListDivider theme={leftSidebarGroupListItemTheme}/>}
      {ui.show && otherGroups && _.map(menuItems, (menuItem, i)=> {
        const menuExtra = menuItem.type == 'division'
          ? divisions.find(d => d.division_id == menuItem.item_id) : otherGroups.find(g => g.group_id == menuItem.item_id)
        const subGroupsId = menuItems.filter(menu => menu.type == 'group' && menu.parent_id == menuItem.item_id).map(menu => menu.item_id)
        const hasSubMenu = otherGroups.find(group => subGroupsId.includes(group.group_id) )
        let rightAction
        if(menuItem.type == 'division' && !expandedDivisions.includes(menuItem.item_id))
          rightAction = [<IconButton key="expand_sub_groups" icon="expand_more" onClick={()=> expandDivision(menuItem.item_id)} />]
        if(menuItem.type == 'division' && expandedDivisions.includes(menuItem.item_id))
          rightAction = [<IconButton key="collapse_sub_groups" icon="expand_less" onClick={()=> collapseDivision(menuItem.item_id)} />]
        if (menuItem.type == 'division' && !hasSubMenu) return null
        if (menuItem.type == 'division')
          return menuExtra && (<ListItem theme={leftSidebarGroupListItemTheme}
            className={(menuExtra.division_id == currentDivisionId && 'active' || '')}
            caption={menuExtra.name} key={menuExtra.division_id}
            avatar={menuExtra.icon_image.thumb_url}
            style={{height:5, width: 5, backgroundColor: '#000', borderRadius: 20}}
            onClick={()=> onSelectDivision(menuExtra.division_id, props) }
            rightActions={rightAction || []}/>)
          return menuExtra && (expandedDivisions.includes(menuItem.parent_id)) && (
            <ListItem theme={leftSidebarGroupListItemTheme}
              className={(menuExtra.group_id == currentGroupId && 'active' || '')+ (' indent ')}
              caption={menuExtra.name} key={menuItem.parent_id + '.' + menuExtra.group_id}
              avatar={menuExtra.icon_image.thumb_url}
              rightActions={menuExtra.unreadCount && [<span key='count' className={leftSidebarGroupListItemTheme.unreadCount}>{menuExtra.unreadCount < 10 ? menuExtra.unreadCount : '10+' }</span>] || []}
              onClick={()=> onSelectGroup(menuExtra.group_id, props) } />)
          }
      )}
      {ui.show && otherGroups && _.map(menuItems, (menuItem, i)=> {
            const menuExtra = otherGroups.find(g => g.group_id == menuItem.item_id && menuItem.is_free_group)
            return menuExtra && (
                <ListItem theme={leftSidebarGroupListItemTheme}
                          className={menuExtra.group_id == currentGroupId && 'active' || ''}
                          caption={menuExtra.name} key={menuExtra.group_id}
                          avatar={menuExtra.icon_image.thumb_url}
                          rightActions={menuExtra.unreadCount && [<span key='count' className={leftSidebarGroupListItemTheme.unreadCount}>{menuExtra.unreadCount < 10 ? menuExtra.unreadCount : '10+' }</span>] || []}
                          onClick={()=> onSelectGroup(menuExtra.group_id, props) } />)
          }
      )}
      {!isFilter && otherGroups &&
        <ListItem selectable={false} ripple={false}
          rightActions={
            [<Button flat key="more"
                icon={ui.show && 'arrow_drop_up' || 'arrow_drop_down'}
                label={ui.show && t('label:隠す') || t('label:すべて表示')}
                onClick={()=> updateUI({ show: !ui.show })}/>]
            } />
      }
    </List>
  )
}

export default ui({ state: { show: false, searchInput: false }})(LeftSidebarGroupList)



// WEBPACK FOOTER //
// ./src/web/components/left-sidebar-group-list.jsx